export default "__VITE_ASSET__BBDx_3Wa__"